<template>
    <div class="page_wrap">
        <!-- <Loading v-if="isLoadingShow" :url="h5Url" :type="2" /> -->
        <div class="authorize_wrap" v-if="isAuthShow">
            <div class="page_con">
                <p class="title">您即将进入方德保险代理公司页面…</p>
                <p class="content">相关服务将由方德保险代理公司提供<br />本人知悉并同意，本人通过点击投米app的链接跳转至方德保险（“第三方机构”）的网页后，即将进入第三方机构网页的服务范围，第三方机构网页的内容和服务均系第三方机构的所有者制作和提供，由第三方机构对其网页内容的合法性、准确性、真实性负责。投米平台作为信息服务机构，不参与产品的销售、管理，不对产品情况提供任何承诺、担保或保证，本人会结合自身情况进行决策。<br />本人知悉并确认，在进入第三方机构的网页后，该网页展示的产品有关资料、文件、内容及数据（统称“产品信息”）的知识产权归第三方机构所有，且该等产品信息仅能提供给特定合格投资者。本人承诺对上述产品信息承担保密义务，并不通过任何方式（包括但不限于互联网媒介，如微信、微信朋友圈、QQ等）复制、下载后向不特定人群提供、转发或扩散该等产品信息。</p>
                <div class="radio_wrap">
                    <i :class="{ radio_icon: true, radio_icon_active: radioActive }" @click="handleRadioClick"></i>
                    <span class="radio_text">我已阅读并同意</span>
                </div>
                <ul class="agreement_list">
                    <li class="agreement_item" v-for="item in agreementList" :key="item.title" @click="gotoDetail(item)">{{ `《${item.title}》` }}</li>
                </ul>
            </div>
            <div class="exclusive-enjoy">
                <button :class="{ bigBtn: true, 'default-button': radioActive, 'disabled-button': !radioActive }" @click="comfirm">确认</button>
            </div>
        </div>
    </div>
</template>
<script>
import Loading from "./fangdeLoading.vue";
import { getUserInfo, bridgeRedirect } from "../../../utils/bridge";
export default {
    data() {
        return {
            isLoadingShow: false,
            isAuthShow: false,
            radioActive: false,
            h5Url: "",
            token: "",
            agreementList: [
                { title: "电子签名数字证书用户使用须知", type: 15 },
                { title: "电子签名数字证书用户申请确认函", type: 16 },
                { title: "信息授权同意函", type: 24 },
                { title: "产品信息共享授权书", type: 25 }
            ]
        };
    },
    components: {
        // Loading
    },
    created() {
        let params = this.$route.query;
        (async function() {
            if (!params.token) {
                const { token } = await getUserInfo();
                this.token = token;
            } else {
                this.token = params.token;
            }
            this.checkAuth();
        }.bind(this)());
    },
    methods: {
        async comfirm() {
            if (!this.radioActive) return;
            try {
                const res = await this.$request({
                    url: "/h5/fangdeUserAuth/auth.json",
                    data: this.$qs.stringify({
                        token: this.token
                    })
                });
                const { code } = res;
                if (code == 1) {
                    //授权成功
                    this.isAuthShow = false;
                    // this.isLoadingShow = true;
                    bridgeRedirect({
                        pageParams: {
                            url: this.h5Url,
                            isNeedRemoveWebView: "1"
                        }
                    });
                }
            } catch (error) {
                this.$toast(error);
            }
        },
        handleRadioClick() {
            this.radioActive = !this.radioActive;
        },
        gotoDetail(data) {
            this.$router.push(`/fangdeAgreement?title=${encodeURI(data.title)}&type=${data.type}&token=${this.token}`);
        },
        // 检查是否授权
        async checkAuth() {
            try {
                const res = await this.$request({
                    url: "/h5/fangdeUserAuth/authInfo.json",
                    data: this.$qs.stringify({
                        token: this.token
                    })
                });
                const {
                    data: { authStatus, fangdeUrl }
                } = res;
                this.h5Url = fangdeUrl;
                if (authStatus === 1) {
                    // 首次进来 未授权
                    this.isAuthShow = true;
                    this.isLoadingShow = false;
                } else if (authStatus === 0) {
                    // 已经授权
                    this.isAuthShow = false;
                    // this.isLoadingShow = true;
                    bridgeRedirect({
                        pageParams: {
                            url: this.h5Url,
                            isNeedRemoveWebView: "1"
                        }
                    });
                }
            } catch (error) {
                this.$toast(error);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.page_wrap {
    .page_con {
        padding: 24px 16px;
        margin-bottom: 85px;
        .title {
            font-family: PingFangSC-Medium;
            font-size: 13px;
            color: #b79659;
            letter-spacing: 0;
            text-align: justify;
            line-height: 22px;
            font-weight: 500;
        }
        .content {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #888888;
            letter-spacing: 0;
            text-align: justify;
            line-height: 22px;
            font-weight: 400;
        }
        .radio_wrap {
            margin-top: 16px;
            display: flex;
            align-items: center;
            .radio_icon {
                display: inline-block;
                width: 16px;
                height: 16px;
                background-size: 16px;
                background-image: url("../../../assets/images/normal/radio_nor.png");
                margin-right: 10px;
                margin-top: 2px;
                &.radio_icon_active {
                    background-image: url("../../../assets/images/normal/radio_ok.png");
                }
            }
            .radio_text {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #aaaaaa;
                letter-spacing: 0;
                font-weight: 400;
            }
        }
        .agreement_list {
            margin: 6px 0 0 26px;
            .agreement_item {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #c0a266;
                letter-spacing: 0;
                font-weight: 400;
                margin-top: 3px;
            }
        }
    }
    .disabled-button {
        background-image: linear-gradient(90deg, #e0dbcf 1%, #d2c1a3 99%);
    }
}
</style>
